import { defineStore } from 'pinia'
import { createEmitter } from '🔗/utils/utils'
import {
    // findOggHeader,
    // findOggPageStart,
    // fetchRange,
    // fetchUnit,
    // loadChunk,
    // calcOggPageSize,
    contributorsPreview
} from '🔗/utils/audio'
import { delay, shuffleCurrentArray } from '🔗/utils/utils';
import stores from '🔗/stores';

// import {
//     // initVorbisWorker,
//     // flush,
//     // decodeAndAppend
// } from '🔗/utils/audio-workers'

// import {
//     // OGG_PRELOAD_CHUNK_COUNT,
//     // KERNEL_BUFFER_SIZE,
// } from '🔗/utils/audio'


export const createPaneStore = (id) =>
    defineStore(`pane-${id}`, {
        state: () => ({
            code: id,
            _ctx: null,
            _gainNode: null,
            // _ringBufferWorkletNode: null,
            _emitter: createEmitter(),

            _lossless: null,
            _item: null,
            // _seek: 0,
            _state: 'stopped',
            _playedSeconds: 0,
            _rewindThreshold: 5, // секунд

            // _dataBuffer: new Uint8Array(0),
            // _position: 0,

            // _oggPageSize: {},

            _crossfadeEnabled: false,
            _crossfadeDuration: 3,

            // _allChunksLoaded: false,
            // _vorbisWorker: null,
            // _vorbisPending: new Map(),
            // _vorbisReqId: 0,
            _queue: {
                items: []
            },

            _repeat: 'none',

            _nativeAudioEnabled: false,
            _nativeAudio: null,
            _nativeSourceNode: null,
            _nativeTapNode: null
        }),

        getters: {
            prevDisabled: (state) => {
                if (!state?._item) {
                    return true;
                }

                if (!state?._queue?.items?.length) {
                    return true;
                }

                const id = state._queue.items.findIndex(item =>
                    item.id === state?._item.id)

                if (id === -1) {
                    return true;
                }

                if (state._playedSeconds > state._rewindThreshold) {
                    return false;
                }

                if (id === 0 && state._repeat !== 'queue') {
                    return true;
                }

                return false;
                // if (id === -1 || id === 0) {
                //     if (state._repeat !== 'queue') {
                //         return true;
                //     }
                // }
            },
            nextDisabled: (state) => {
                if (!state?._item) {
                    return true;
                }

                if (!state?._queue?.items?.length) {
                    return true;
                }

                const id = state._queue.items.findIndex(item =>
                    item.id === state?._item.id)

                if (id === -1 || id === state._queue.items.length - 1) {
                    if (state._repeat !== 'queue') {
                        return true;
                    }
                }
            },
            inQueue: (state) => (id) => {
                if (!state?._queue?.items?.length) {
                    return false;
                }

                return !!state._queue.items.find(item =>
                    item.id === id || item.code === id);
            },
            isNext: (state) => (id) => {
                if (!state?._queue?.items?.length) {
                    return false;
                }

                const current = state._queue.items.findIndex(item => item?.id && item.id === state._item?.id);
                if (current === -1 || current === state._queue.items.length - 1) {
                    return;
                }

                return state._queue.items[current + 1]?.id === id;
            },
            hasQueue: (state) => {
                return !!state?._queue?.items?.length;
            }
        },

        actions: {
            /** Инициализация узлов Audio API */
            async setup({ audioContext, channelCount, mediaSession, nativeAudio = true }) {
                this._nativeAudioEnabled = nativeAudio;
                this._ctx = audioContext;
                this._mediaSession = mediaSession;
                this._gainNode = audioContext.createGain();
                this._gainNode.connect(audioContext.destination);

                // this._ringBufferWorkletNode = new AudioWorkletNode(
                //     audioContext,
                //     'ring-buffer-worklet',
                //     {
                //         processorOptions: {
                //             kernelBufferSize: KERNEL_BUFFER_SIZE,
                //             channelCount: channelCount || 2
                //         },
                //         numberOfOutputs: 1,
                //         outputChannelCount: [channelCount || 2],
                //         channelCount: channelCount || 2,
                //         channelCountMode: 'explicit',
                //     },
                // )

                // this._ringBufferWorkletNode.connect(this._gainNode);

                // // реакция на события из worklet’а
                // this._ringBufferWorkletNode.port.onmessage = async (event) => {
                //     const data = event.data;

                //     if (data.event === 'needMoreData') {
                //         // Загружаем чанки
                //         await loadChunk(this, this._item?.id)

                //         if (this.state() === 'playing') {
                //             // Декодируем
                //             await decodeAndAppend(this)
                //         }
                //     }

                //     if (data.event === 'playedSeconds') {
                //         this.playedSeconds(data.value)
                //     }
                // }
            },

            initNativeAudio() {
                if (this._nativeAudio) return;

                const audio = document.createElement('audio');
                audio.preload = 'auto';
                audio.crossOrigin = 'anonymous';


                const track = this._ctx.createMediaElementSource(audio);
                track.connect(this._gainNode);
                // audio.muted = true;

                // const source = this._ctx.createMediaElementSource(audio);

                // const tap = new AudioWorkletNode(this._ctx, 'native-audio-tap', {
                //     numberOfInputs: 1,
                //     numberOfOutputs: 1,
                //     outputChannelCount: [2],
                //     channelCount: 2,
                //     channelCountMode: 'explicit',
                // });

                // tap.port.onmessage = (e) => {
                //     const { ch0, ch1 } = e.data;

                //     console.log(ch0, ch1)

                //     this._ringBufferWorkletNode.port.postMessage({
                //         command: 'append',
                //         data: [ch0, ch1]
                //     }, [
                //         ch0.buffer,
                //         ch1.buffer
                //     ]);
                // };

                // source.connect(tap);

                audio.addEventListener('timeupdate', () => {
                    if (this.state() !== 'playing') {
                        return;
                    }

                    this.playedSeconds(audio.currentTime);
                });

                audio.addEventListener('ended', () => {
                    this.onEnd();

                    if (this.repeat() === 'track') {
                        this.play();
                    } else {
                        this.next();
                    }
                });


                this._nativeAudio = audio;
                // this._nativeSourceNode = source;
                // this._nativeTapNode = tap;
            },

            crossfadeEnabled(payload) {
                if ([undefined, null].indexOf(payload) !== -1) {
                    return this._crossfadeEnabled;
                }

                this._crossfadeEnabled = !!payload;

                // this._ringBufferWorkletNode.port.postMessage({
                //     command: this._crossfadeEnabled ? 'enableCrossfade' : 'disableCrossfade'
                // });


                return this._crossfadeEnabled;
            },

            crossfadeDuration(payload) {
                if ([undefined, null].indexOf(payload) !== -1) {
                    return this._crossfadeDuration;
                }

                if (payload > 0) {
                    this._crossfadeDuration = +payload || 3;

                    // this._ringBufferWorkletNode.port.postMessage({
                    //     command: 'setCrossfadeDuration',
                    //     data: this._crossfadeDuration
                    // });
                }

                return this._crossfadeDuration;
            },

            queue(payload) {
                if (payload) {
                    this._queue = payload;
                }

                return this._queue;
            },

            repeat(payload) {
                if (payload) {
                    this._repeat = payload;
                }

                return this._repeat;
            },

            clearQueue() {
                delete this._queue;
            },

            removeFromQueue(id) {
                if (!this._queue?.items?.length) {
                    return
                }

                const current = this._queue.items.find(item => item?.id && item.id === id);

                if (this._item?.id === id) {
                    if (!this.nextDisabled) {
                        this.next();
                    } else {
                        this.stop();
                    }
                }

                if (current) {
                    this._queue.items.splice(this._queue.items.indexOf(current), 1);
                }
            },

            addToQueue(track) {
                if (!this._queue?.items) {
                    return
                }

                this._queue.items.push(track);
            },

            playNext(track) {
                if (!this._queue?.items?.length || !track?.id) {
                    return
                }

                const current = this._queue.items.find(item => item?.id && item.id === this._item?.id);

                if (!current) {
                    return;
                }

                const ourTrack = this._queue.items.find(item => item?.id && item.id === track?.id);
                if (ourTrack) {
                    this._queue.items.splice(this._queue.items.indexOf(ourTrack), 1);
                }

                this._queue.items.splice(this._queue.items.indexOf(current) + 1, 0, ourTrack || track);
            },
            

            shuffleQueue() {
                if (!this._queue?.items?.length) {
                    return
                }

                const current = this._queue.items.find(item => item?.id && item.id === this._item?.id);

                if (current) {
                    this._queue.items.splice(this._queue.items.indexOf(current), 1);
                }


                shuffleCurrentArray(this._queue.items);

                if (current) {
                    this._queue.items.unshift(current);
                }
            },

            async loadMore() {
                if (!this._queue?.items?.length || this._queue?.items.indexOf(this._item) < this._queue?.items.length - 2) {
                    return;
                }

                if (!this._queue?.load || !this._queue?.total || this._queue.total === this._queue.skip) {
                    return;
                }

                const payload = await this._queue.load(this._queue.skip);

                if (!payload?.items?.length || !payload?.total) {
                    return;
                }


                this._queue.items.splice(this._queue.items.length, 0, ...payload.items);
                this._queue.total = payload.total;
            },

            async prev() {
                const queue = this.queue();

                if (!queue?.items?.length) {
                    return;
                }

                if (!this._item?.id) {
                    return;
                }

                if (this._playedSeconds > this._rewindThreshold) {
                    await this.seek(0);
                    return;
                }

                let id = queue.items.findIndex(item => item?.id === this._item.id);
                
                if (id === -1 || id === 0) {
                    if (this.repeat() === 'queue') {
                        id = queue.items.length - 1;
                    } else {
                        return;
                    }
                }

                await this.open(queue.items[id - 1])
                await this.play();
            },

            async next() {
                const queue = this.queue();

                if (!queue?.items?.length) {
                    return;
                }

                if (!this._item?.id) {
                    return;
                }

                let id = queue.items.findIndex(item => item?.id === this._item.id);

                if (id === -1 || id === queue.items.length - 1) {
                    if (this.repeat() === 'queue') {
                        id = 0;
                    } else {
                        return;
                    }
                }

                await this.open(queue.items[id + 1])
                await this.play();
            },

            async playById(payload) {
                const queue = this.queue();

                if (!queue?.items?.length) {
                    return;
                }

                const id = queue.items.findIndex(item => item?.id === payload);

                if (id === -1) {
                    return;
                }

                await this.open(queue.items[id])
                await this.play();
            },

            /** Открыть */
            async open(item) {
                if (!item) {
                    return;
                }

                // Если этого трека нет в нашей очереди, то обнуляем её
                if (!this._queue?.items?.find(subitem => subitem.id === item.id)) {
                    this.queue({});
                }

                await this.stop();
                this._item = item;

                if (this._nativeAudioEnabled) {
                    this.initNativeAudio();
                    this._nativeAudio.src = `${import.meta.env.VITE_APP_API_URL}/track/stream-no-auth/${item.id}/${this.format()}`; // или contributorsPreview
                }

                this._emitter.emit('open', { item });


                if (this._mediaSession) {
                    // Album
                        let album;

                        if (this._queue?.type === 'release') {
                            album = this._queue.release?.title;
                        }

                        if (this._queue?.type === 'playlist') {
                            album =  stores.locale().title(this._queue.playlist?.title);
                        }

                        if (this._queue?.type === 'dict') {
                            album =  stores.locale().title(this._queue.dict?.title);
                        }


                    // Artist
                        let artist;
                        if (!this._item.type || this._item.type === 'track') {
                            artist = contributorsPreview(this._item.contributors);
                        }

                    this._mediaSession.open({
                        title: this._item?.title,
                        artist,
                        album,
                        artwork: this._item.cover?.crop ? [
                          { src: `${import.meta.env.VITE_APP_FILES_URL}${this._item.cover?.resized}`, sizes: '1000x1000', type: 'image/png' },
                          { src: `${import.meta.env.VITE_APP_FILES_URL}${this._item.cover?.crop}`, sizes: '180x180', type: 'image/png' }
                        ] : [],
                        duration: parseInt(this._item.duration / 1000)
                    })
                }

                // Подгрузa
                this.loadMore();

                return true
            },

            // Громкость
            gain(payload) {
                if (payload !== null && payload !== undefined) {
                    this._gainNode.gain.value = +payload;
                }

                return this._gainNode.gain.value;
            },

            /** Воспроизвести */
            async play() {
                if (this.state() !== 'stopped' || !this._item?.id) {
                    return;
                }

                this.state('playing');

                if (this._nativeAudioEnabled) {
                    // this._ringBufferWorkletNode.port.postMessage({ command: 'clear' });
                    await this._nativeAudio.play();
                    return;
                }

                // const id = this._item?.id;

                // // Preload
                // if (this.format() === 'ogg') {
                //     // Инициализируем воркер
                //     await this.initVorbisWorker();

                //     // Загружаем первые чанки
                //     for (let i = 0; i < OGG_PRELOAD_CHUNK_COUNT; i++) {
                //         const ok = await loadChunk(this, id, 'fast');
                //         if (!ok) {
                //             break;
                //         }
                //     }
                // }

                // if (id !== this._item?.id) {
                //     return;
                // }

                // // Чистим наш кольцевой буффер
                // this._ringBufferWorkletNode.port.postMessage({
                //     command: 'clear'
                // });

                // if (this.state() === 'playing') {
                //     // Декодируем
                //     await decodeAndAppend(this);
                // }
            },

            async pause() {
                if (this._nativeAudioEnabled) {
                    this._nativeAudio.pause();
                }
                //  else {
                //     this._ringBufferWorkletNode.port.postMessage({
                //         command: 'pause'
                //     });
                // }

                this.state('paused');
            },

            async resume() {
                if (this.state() !== 'paused') {
                    return;
                }

                if (this._nativeAudioEnabled) {
                    await this._nativeAudio.play();
                }
                // else {
                //     this._ringBufferWorkletNode.port.postMessage({
                //         command: 'resume'
                //     });
                //     await decodeAndAppend(this);
                // }

                this.state('playing');
            },

            async stop() {
                if (this._nativeAudioEnabled && this._nativeAudio) {
                    this._nativeAudio.pause();
                    this._nativeAudio.currentTime = 0;
                }

                // this._ringBufferWorkletNode.port.postMessage({
                //     command: 'clear'
                // });

                // this._position = 0;
                // this._seek = 0;
                this._playedSeconds = 0;
                // delete this._seekLock;
                // delete this.oggHeader;
                // delete this._durationInBytes;
                // this._dataBuffer = new Uint8Array(0);
                this.state('stopped');
            },

            /** Перемотка */
            async seekbackward(offset = 10 * 1000) {
                const pos = Math.max(0, this._playedSeconds * 1000 - offset);
                await this.seek(pos);
            },
            async seekforward(offset = 10 * 1000) {
                const pos = Math.min(this._item.duration - 5 * 1000, this._playedSeconds * 1000 + offset);
                await this.seek(pos);
            },
            async seek(pos) {
                // console.log(pos)
                if (this._nativeAudioEnabled) {
                    this._nativeAudio.currentTime = pos / 1000;
                    this.playedSeconds(this._nativeAudio.currentTime);
                    // this._seek = pos;
                    // this._playedSeconds = 0;
                    return;
                }

                // // Ограничения
                //     if (this._seekLock) {
                //         return;
                //     }

                //     if ([null, undefined].indexOf(pos) !== -1) {
                //         return;
                //     }

                //     if (pos < 0) {
                //         return;
                //     }

                //     if (this._item.duration && pos >= this._item.duration) {
                //         return;
                //     }

                //     if (!this._item.duration || !this._durationInBytes) {
                //         return;
                //     }

                // // Начальные обнуления, а то я уже с ума схожу
                //     this._seek = pos;
                //     this._playedSeconds = 0;
                //     this._seekLock = true;

                // // Заставляем декодер раздуплить остатки
                //     flush(this);

                // // Вычисляем что нам нужно подгрузить и подгружаем
                //     const approximateBytePos = Math.floor(this._durationInBytes * (pos / this._item.duration));
                //     const rangeSize = 64 * 1024;
                //     const start = Math.max(0, approximateBytePos - rangeSize / 2);
                //     const end = Math.min(this._durationInBytes - 1, start + rangeSize - 1);

                //     // Загружаем кусок данных
                //     const data = await fetchRange(this, start, end);

                //     const offsetInChunk = findOggPageStart(data);

                //     if (offsetInChunk === -1) {
                //         return;
                //     }

                // // Актуализируем положение
                //     this._position = start + offsetInChunk;
                //     this._seek = parseInt(this._item.duration * (start + offsetInChunk) / this._durationInBytes);

                // if (this.state() !== 'playing') {
                //     delete this._seekLock;
                //     return;
                // }

                // this.pause();
                // this.state('playing');

                // // Preload
                // const id = this._item?.id;

                // this._allChunksLoaded = false;


                // if (this.format() === 'ogg') {
                //     // Загружаем первые чанки
                //     for (let i = 0; i < 1; i++) {
                //         const ok = await loadChunk(this, id, 'seek');
                //         if (!ok) {
                //             break;
                //         }
                //     }
                // }

                // if (id !== this._item?.id) {
                //     delete this._seekLock;
                //     return;
                // }


                // // Чистим наш кольцевой буффер
                // this._ringBufferWorkletNode.port.postMessage({
                //     command: 'strongClear'
                // });

                // delete this._seekLock;


                // this._playedSeconds = 0;

                // // Обновляем медиа сессию
                // if (this._mediaSession) {
                //     this._mediaSession.position({
                //         duration: parseInt(this._item?.duration / 1000),
                //         playbackRate: 1,
                //         position: parseInt(this._seek / 1000) + this._playedSeconds
                //     });
                // }


                // // Декодируем
                // await decodeAndAppend(this);
            },

            // async initVorbisWorker() {
            //     this._dataBuffer = new Uint8Array(0);

            //     const oggHeader = await findOggHeader(this);
            //     this._position = oggHeader.byteLength;
            //     this._seek = 0;
            //     delete this._seekLock;
            //     this._allChunksLoaded = false;

            //     await initVorbisWorker(this);

            //     // Инициализируем декодер в воркере с oggHeader (один раз)
            //     // Используем id чтобы дождаться initDone (если воркер его шлёт)
            //     const initId = ++this._vorbisReqId;
            //     const initPromise = new Promise((resolve, reject) => {
            //         this._vorbisPending.set(initId, { resolve, reject });
            //     });

            //     // посылаем oggHeader (transfer)
            //     const headerAB = oggHeader instanceof Uint8Array ? oggHeader.buffer.slice(oggHeader.byteOffset, oggHeader.byteOffset + oggHeader.byteLength) : (oggHeader.buffer || oggHeader);

            //     this._vorbisWorker.postMessage({
            //         pane: this.code,
            //         id: initId, cmd: 'initDecoder',
            //         data: { oggHeader: headerAB }
            //     }, [headerAB]);
            //     // не обязателен, но ждем подтверждения и игнорируем результат
            //     try {
            //         await initPromise;
            //     } catch (err) {
            //         // если init не подтвердился — всё равно продолжаем, воркер может получать pages без явного initDone
            //         console.warn('Vorbis init promise rejected or timed out', err);
            //     }
            // },

            // async pageSize() {
            //     if (!this._oggPageSize[this._item.id]) {
            //         const firstChunk = await fetchRange(this, 0, 4095);
            //         const pageSize = calcOggPageSize(firstChunk)

            //         this._oggPageSize[this._item.id] = pageSize || 58;
            //     }

            //     return this._oggPageSize[this._item.id];
            // },

            format(payload) {
                if (payload) {
                    this._format = payload;
                }

                if (this._lossless === null) {
                    return this._format || 'ogg';
                }

                return this.lossless ? 'wav' : 'ogg'
            },

            state(payload) {
                if (payload) {
                    this._state = payload
                    this._emitter.emit('state', { state: this._state, item: this._item })

                    if (this._mediaSession) {
                        if (payload === 'playing') {
                            this._mediaSession.play();
                        }
                        if (payload === 'paused') {
                            this._mediaSession.pause();
                        }
                        if (payload === 'stopped') {
                            this._mediaSession.stop();
                        }
                    }
                }
                return this._state
            },

            onEnd() {
                this.stop();
                this._emitter.emit('end', { item: this._item });
            },

            playedSeconds(payload) {
                // console.log(payload);
                // if (this._nativeAudioEnabled && this._nativeAudio) {
                //     this._playedSeconds = this._nativeAudio.currentTime;
                // }

                if (payload !== null && payload !== undefined) {
                    this._playedSeconds = payload;

                    this._emitter.emit('position', {
                        position: this._playedSeconds,
                        item: this._item
                    });


                    // const next = async () => {
                    //     if (this.nextLock) {
                    //         return;
                    //     }
                    //     this.nextLock = true;
                    //     await delay(2000);

                    //     await this.onEnd();
                    //     this.next();
                    //     this.nextLock = false;
                    // }

                //     // Если воспроизведение подошло к концу
                //     if (this._crossfadeEnabled) {
                //         if (this._seek + this._playedSeconds * 1000 >= this._item?.duration - 2000 - this._crossfadeDuration * 1000) {
                //             next()
                //         }
                //     } else {
                        // if (this._seek + this._playedSeconds * 1000 >= this._item?.duration - 2000) {
                        //     next()
                        // }
                //     }

                    if (this._mediaSession) {
                        this._mediaSession.position({
                            duration: parseInt(this._item?.duration / 1000),
                            playbackRate: 1,
                            position: this._playedSeconds
                        });
                    }

                }

                return this._playedSeconds;
            },

            on(ev, h) { this._emitter.on(ev, h) },
            off(ev, h) { this._emitter.off(ev, h) },
            emit(ev, h) { this._emitter.emit(ev, h) },
        },
    })
